import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/editDoc.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_SideBar = _resolveComponent("SideBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_btn, {
      class: "badge-danger btn tw-document-trigger-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSideBarToggle())),
      floating: "",
      disable: _ctx.noDocs
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1)
      ]))]),
      _: 1
    }, 8, ["disable"]),
    (_ctx.showSideBar)
      ? (_openBlock(), _createBlock(_component_SideBar, {
          key: 0,
          show: _ctx.showSideBar,
          component: _ctx.printDocument,
          label: 'GeneratedDocuments',
          onOnClose: _ctx.disappearSideBarToggle,
          props: _ctx.componentPropsSB
        }, null, 8, ["show", "component", "onOnClose", "props"]))
      : _createCommentVNode("", true)
  ], 64))
}